import { render, staticRenderFns } from "./skill.vue?vue&type=template&id=2c4bcc8a&scoped=true&"
import script from "./skill.vue?vue&type=script&lang=js&"
export * from "./skill.vue?vue&type=script&lang=js&"
import style0 from "./skill.vue?vue&type=style&index=0&id=2c4bcc8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bcc8a",
  null
  
)

export default component.exports